import { ServicePageHeader, ServicePageCTA, SubServiceCard } from "@/components/ServicePageBits";

const SUBSERVICES = [
  {
    title: "Web Design Services",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1400&q=80",
    body: [
      "We design interfaces that feel inevitable — fast to read, easy to act on, and tuned to your brand.",
      "From wireframes to high-fidelity prototypes, our UX/UI team partners with you to ship designs that convert.",
    ],
    tools: ["Figma", "Adobe XD", "Tailwind", "Framer Motion"],
    readMoreHref: "https://thantrick.org/web-design/",
  },
  {
    title: "Web Development Services",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1400&q=80",
    body: [
      "End-to-end web app engineering — from MVPs to production-grade SaaS — built with modern stacks and a tight CI/CD loop.",
      "We own deployment, performance, observability and security so you can focus on your business.",
    ],
    tools: ["React", "Next.js", "Node.js", "Python/FastAPI", "Postgres", "MongoDB", "AWS"],
    readMoreHref: "https://thantrick.org/web-development-2/",
  },
  {
    title: "Mobile Development Services",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1400&q=80",
    body: [
      "Native and cross-platform apps for iOS and Android with offline-first patterns, push notifications and store-ready release pipelines.",
      "Whether you need a parent app, a field-ops tool, or a customer-facing product — we ship.",
    ],
    tools: ["React Native", "Expo", "Swift", "Kotlin", "Firebase"],
    readMoreHref: "https://thantrick.org/mobile-development/",
  },
];

export default function Software() {
  return (
    <div data-testid="page-software">
      <ServicePageHeader
        eyebrow="Software services"
        title="Software that ships, scales and stays out of the way."
        breadcrumb="Home / Services / Software"
        lead={
          "From thoughtful UI to deployed mobile apps, our software team brings design, engineering and operations under one roof. Three offerings — one team — zero handoff drag."
        }
      />

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-20">
          {SUBSERVICES.map((s, i) => (
            <SubServiceCard key={s.title} {...s} reverse={i % 2 === 1} />
          ))}
        </div>
      </section>

      <ServicePageCTA />
    </div>
  );
}
